<template>
  <div style="
      width: 100%;
      top: 7vh;
      bottom: 0px;
      inset-inline-end: 0px;
      height: 100vh;
      z-index: 1030;
      background-color: #f1f1f1;
    " v-if="remoteEP">
    <vmaatu :query="simpleMeetingsQuery" v-if="
        endpoint &&
        endpoint.videoConfEPType == 'VMAATU_RTC' &&
        simpleMeetingsQuery
      " ref="vmaatu" :remote-alert="remoteCart.HAS_OBSTRUCTION" :pinch-zoom-enabled="PINCH_ZOOM_ENABLED"></vmaatu>

    <webex-teams :query="simpleMeetingsQuery" v-if="
        endpoint &&
        endpoint.videoConfEPType == 'SPARK_EMBEDDED' &&
        simpleMeetingsQuery
      " ref="webex"></webex-teams>

    <!-- Joysticm for rc-->
    <div class="zone joystick" v-if="remoteEP.roboticControls.enabled"></div>

    <!-- Slider for camera tilt-->
    <div class="zone slider" v-if="remoteEP.roboticControls.enabled"></div>

    <!-- Joysticm for ptz-->
    <div class="floating-ptz" v-if="!remoteEP.roboticControls.enabled">
      <div class="circleMenu">
        <nav>
          <ul class="outer">
            <li>
              <span class="mainBtn" @click="ptzExecute('reset','None')" @contextmenu="false">
                <i class="fa fa-sync-alt" style="margin-left: 31%;margin-top: 31%;color: #637BEF;font-size: 1.3em;"></i>
              </span>
              <ul class="inner" @contextmenu="false">
                <li @mousedown="ptzExecute('pan','Left')" @mouseup="ptzExecute('pan','Stop')" @touchstart="ptzExecute('pan','Left')" @touchend="ptzExecute('pan','Stop')" @contextmenu="false"><i class="fa fa-chevron-left fa-2x"></i></li>
                <li @mousedown="ptzExecute('tilt','Up')" @mouseup="ptzExecute('tilt','Stop')" @touchstart="ptzExecute('tilt','Up')" @touchend="ptzExecute('tilt','Stop')" @contextmenu="false"><i class="fa fa-chevron-up fa-2x"></i></li>
                <li @mousedown="ptzExecute('pan','Right')" @mouseup="ptzExecute('pan','Stop')" @touchstart="ptzExecute('pan','Right')" @touchend="ptzExecute('pan','Stop')" @contextmenu="false"><i class="fa fa-chevron-right fa-2x"></i></li>
                <li @mousedown="ptzExecute('tilt','Down')" @mouseup="ptzExecute('tilt','Stop')" @touchstart="ptzExecute('tilt','Down')" @touchend="ptzExecute('tilt','Stop')" @contextmenu="false"><i class="fa fa-chevron-down fa-2x"></i></li>
              </ul>
            </li>
          </ul>
        </nav>
      </div>
    </div>

    <ul class="zoom-buttons" @contextmenu="false" v-if="!remoteEP.roboticControls.enabled">
      <li @mousedown="ptzExecute('zoom','In')" @mouseup="ptzExecute('zoom','Stop')" @touchstart="ptzExecute('zoom','In')" @touchend="ptzExecute('zoom','Stop')" @contextmenu="false">
        <span class="fa-stack fa-lg">
          <i class="fa fa-circle fa-stack-2x"></i>
          <i class="fa fa-search-plus fa-stack-1x fa-inverse zoom-in"></i>
        </span>
      </li>
      <li @mousedown="ptzExecute('zoom','Out')" @mouseup="ptzExecute('zoom','Stop')" @touchstart="ptzExecute('zoom','Out')" @touchend="ptzExecute('zoom','Stop')" @contextmenu="false">
        <span class="fa-stack fa-lg">
          <i class="fa fa-circle fa-stack-2x"></i>
          <i class="fa fa-search-minus fa-stack-1x fa-inverse zoom-out"></i>
        </span>
      </li>
    </ul>

    <n-button type="primary" round icon @click.native="endIcu" class="close-button">
      <i class="fas fa-times fa-lg"></i>
    </n-button>

    <div class="battery-status" v-if="remoteEP.batteryStatus">
      <div class="batteryContainer">
        <span class="mr-1" style="color: #fff;">{{ getBatteryPercnetage(remoteEP.batteryStatus.batteryChargePercentage)}}<span>%</span></span>
        <div class="batteryOuter">
          <div id="batteryLevel" :style="{width: getBatteryPercnetage(remoteEP.batteryStatus.batteryChargePercentage) + '%',backgroundColor: (remoteEP.batteryStatus.batteryChargePercentage >15) ? '#18ce0f' :'#d82e2e'}"></div>
        </div>
        <div class="batteryBump"></div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import settings from "../../../settings";
import socket from "../../../services/socket";
import nipplejs from "nipplejs";

export default {
  name: "IcuVisit",
  data() {
    return {
      endpoint: null,
      appointment: null,
      simpleMeetingsQuery: null,
      settings: null,
      //remote control
      commandDelay: settings.COMMAND_DELAY,
      moveFrontHandler: null,
      moveBackHandler: null,
      moveLeftHandler: null,
      moveRightHandler: null,
      moveUpHandler: null,
      moveDownHandler: null,
      remoteCart: {
        MOVING_FRONT: false,
        MOVING_RIGHT: false,
        MOVING_BACK: false,
        MOVING_LEFT: false,
        MOVING_NORTH_EAST: false,
        MOVING_SOUTH_EAST: false,
        MOVING_SOUTH_WEST: false,
        MOVING_NORTH_WEST: false,

        TILTING_UP: false,
        TILTING_DOWN: false,

        HAS_OBSTRUCTION: false,
      },
      cameraTiltSliderValue: 1,
      ENDPOINT_SET_FREE: false,
      appointmentId: null,
      patient: null,
      prescription: null,
      opinion: null,
      remoteEP: null,
      vmaatuURL: "",
      vmaatu: false,
      ptzTimer: null,

      //Robotic cart with windows PC
      moveCartHandler: null,
      previousDirection: null,

      obstructionAlertInterval: null,
      PINCH_ZOOM_ENABLED: false,
    };
  },
  async mounted() {
    let that = this;
    this.endpoint = this.$store.state.icuEndpoint;
    this.appointment = this.$store.state.icuAppointment;
    //to end Icu on back event
    this.$root.onBackButton = () => {
      this.endIcu();
    };
    //init Icu
    console.log("Appointment ID : " + this.appointment._id);
    this.appointmentId = this.appointment._id;

    //Join Appointment Room
    socket.emit("joinRoom", {
      type: "appointment",
      id: this.appointmentId,
      userId: this.user._id,
    });

    let appointmentData = await this.$store.dispatch(
      "getAppointment",
      this.appointmentId
    );
    console.log(
      "Successul Got Appointment details " + JSON.stringify(appointmentData)
    );
    this.appointment = appointmentData;
    this.patient = this.appointment.patient;
    this.appointment.createdFormatted = moment(this.appointment.created).format(
      "MMMM Do YYYY, h:mm:ss a"
    );

    if (this.appointment.patient && this.appointment.patient.patientId) {
      this.getPrescription(
        this.appointment._id,
        this.appointment.patient.patientId
      );
    }

    //Set opinion of secondary provider if already present
    if (
      this.appointment.secondaryProviders &&
      this.appointment.secondaryProviders.length > 0
    ) {
      this.appointment.secondaryProviders.forEach(function (provider, index) {
        var found = false;

        if (this.user._id == provider.providerId && !found) {
          this.opinion = this.appointment.secondaryProviders[index].opinion;
          found = true;
        }
      });
    }

    //Join endpoint name socket room for data transfer bewteen icu user
    socket.emit("joinRoom", {
      type: "endpoint",
      id: this.appointment.endpoint,
      userId: this.user._id,
    });
    socket.emit("joinRoom", {
      type: "appointment",
      id: this.appointment._id,
      userId: this.user._id,
    });

    socket.emit("icuVisitStart", {
      endpoint: this.appointment.endpoint,
      appointmentId: this.appointment._id,
      providerId: this.user._id,
      providerName: this.user.firstName + " " + this.user.lastName,
    });

    try {
      //get settings
      let settingsData = await this.$store.dispatch("getSettings");
      this.settings = settingsData;

      try {
        //Fetching endpoint details
        this.remoteEP = await this.$store.dispatch(
          "getEndpointDetails",
          this.appointment.endpoint
        );

        try {
          let endpoint2 = await this.$store.dispatch(
            "getEndpointDetails",
            this.user.endpoint.name
          );
          this.endpoint = endpoint2;

          //Checking for VC EP type
          if (this.endpoint.videoConfEPType == "VMAATU_RTC") {
            //Generating VC URL
            let simpleMeetingsQuery = {
              api_key: this.settings.vMaatuSettings.apikey,
              room_name: this.instance + "_" + this.appointment.endpoint,
              user_name: this.user.username,
              tenant_name: this.user.tenant.name,
              instance: this.instance,
            };

            if (
              this.settings.vMaatuSettings.recordingEnabled &&
              this.user.endpoint.cameraSetting.recordingEnabled
            ) {
              simpleMeetingsQuery.enable_recording = "true";

              if (this.settings.vMaatuSettings.recordingResolution) {
                simpleMeetingsQuery.recording_resolution =
                  this.settings.vMaatuSettings.recordingResolution;
              }

              if (this.settings.vMaatuSettings.recordingFrameRate) {
                simpleMeetingsQuery.recording_frame_rate =
                  this.settings.vMaatuSettings.recordingFrameRate;
              }

              if (this.settings.vMaatuSettings.autoRecordingEnabled) {
                simpleMeetingsQuery.auto_recording = "true";
              }
            }

            this.simpleMeetingsQuery = simpleMeetingsQuery;

            this.vmaatu = true;
            setTimeout(() => {
              that.$refs.vmaatu.init();
            }, 1000);
          } else if (
            this.endpoint.videoConfEPType == "SPARK_EMBEDDED" ||
            this.endpoint.videoConfEPType == "WEBEXTEAMS_GUEST"
          ) {
            //Generating webex url link
            this.simpleMeetingsQuery = {
              access_token: this.user.oauthInfo.ciscospark.accessToken,
              destination: this.appointment.webexTeams.roomId,
              user_name: this.user.username,
              tenant_name: this.user.tenant.name,
              room_name: this.instance + "_" + this.appointment._id,
            };
            this.vmaatu = true;
          }
          console.log("simpleMeetingsQuery", this.simpleMeetingsQuery);
        } catch (err) {
          console.log("Error getting endpoint details", err);
        }
      } catch (err) {
        console.log("Error getting endpoint details", err);
      }
    } catch (err) {
      console.log(
        "Error Getting the appointment details for id " + this.appointmentId,
        err
      );
    }

    //Robotic cart controls
    if (this.remoteEP.roboticControls.enabled) {
      this.PINCH_ZOOM_ENABLED = true;
      var options = {
        zone: document.querySelector(".zone.joystick"),
        mode: "static",
        position: {
          top: "60%",
        },
        color: "grey",
        multitouch: true,
      };

      if (document.documentElement.dir == "rtl") {
        options.position.left = "100px";
      } else {
        options.position.right = "100px";
      }

      var joystick = nipplejs.create(options);

      joystick.on("move", (data, data2) => {
        let angle = data2.angle.degree;

        //Front
        if (angle > 67.5 && angle < 112.5) {
          if (!that.remoteCart.MOVING_FRONT) {
            that.startMoveFront();
          }
        } else if (that.remoteCart.MOVING_FRONT) {
          that.endMoveFront();
        }

        //North East
        if (angle > 22.5 && angle < 67.5) {
          if (!that.remoteCart.MOVING_NORTH_EAST) {
            that.startMoveNorthEast();
          }
        } else if (that.remoteCart.MOVING_NORTH_EAST) {
          that.endMoveNorthEast();
        }

        //Right
        if (angle > 337.5 || angle < 22.5) {
          if (!that.remoteCart.MOVING_RIGHT) {
            that.startMoveRight();
          }
        } else if (that.remoteCart.MOVING_RIGHT) {
          that.endMoveRight();
        }

        //South east
        if (angle > 292.5 && angle < 337.5) {
          if (!that.remoteCart.MOVING_SOUTH_EAST) {
            that.startMoveSouthEast();
          }
        } else if (that.remoteCart.MOVING_SOUTH_EAST) {
          that.endMoveSouthEast();
        }

        //Back
        if (angle > 247.5 && angle < 292.5) {
          if (!that.remoteCart.MOVING_BACK) {
            that.startMoveBack();
          }
        } else if (that.remoteCart.MOVING_BACK) {
          that.endMoveBack();
        }

        //South West
        if (angle > 202.5 && angle < 247.5) {
          if (!that.remoteCart.MOVING_SOUTH_WEST) {
            that.startMoveSouthWest();
          }
        } else if (that.remoteCart.MOVING_SOUTH_WEST) {
          that.endMoveSouthWest();
        }

        //left
        if (angle > 157.5 && angle < 202.5) {
          if (!that.remoteCart.MOVING_LEFT) {
            that.startMoveLeft();
          }
        } else if (that.remoteCart.MOVING_LEFT) {
          that.endMoveLeft();
        }

        //North West
        if (angle > 112.5 && angle < 157.5) {
          if (!that.remoteCart.MOVING_NORTH_WEST) {
            that.startMoveNorthWest();
          }
        } else if (that.remoteCart.MOVING_NORTH_WEST) {
          that.endMoveNorthWest();
        }
      });

      joystick.on("end", () => {
        that.endMoveFront();
        that.endMoveRight();
        that.endMoveBack();
        that.endMoveLeft();
        that.endMoveNorthEast();
        that.endMoveSouthEast();
        that.endMoveSouthWest();
        that.endMoveNorthWest();
      });
    }

    //Robotic cart camera slider
    if (this.remoteEP.roboticControls.enabled) {
      var options2 = {
        zone: document.querySelector(".zone.slider"),
        mode: "static",
        position: {
          top: "60%",
        },
        color: "grey",
        multitouch: true,
        lockY: true,
        shape: "square",
      };

      if (document.documentElement.dir == "rtl") {
        options2.position.right = "100px";
      } else {
        options2.position.left = "100px";
      }

      var cameraControl = nipplejs.create(options2);

      cameraControl.on("move", (data, data2) => {
        if (data2.direction) {
          let direction = data2.direction.y;

          if (direction == "up") {
            if (!this.remoteCart.TILTING_UP) {
              this.startMoveUp();
            }
          } else {
            this.stopMoveUp();
          }

          if (direction == "down") {
            if (!this.remoteCart.TILTING_DOWN) {
              this.startMoveDown();
            }
          } else {
            this.stopMoveDown();
          }
        }
      });

      cameraControl.on("end", (data, data2) => {
        this.stopMoveUp();
        this.stopMoveDown();
      });
    }

    socket.on("roboticCartSensorEvent", (data) => {
      if (
        data &&
        data.sensorObstructionEvents &&
        data.sensorObstructionEvents.length
      ) {
        clearInterval(that.obstructionAlertInterval);
        that.remoteCart.HAS_OBSTRUCTION = true;

        that.obstructionAlertInterval = setInterval(() => {
          that.remoteCart.HAS_OBSTRUCTION = false;
        }, 2000);
      }
    });
  },
  methods: {
    getBatteryPercnetage(value) {
      return Math.min(value, 100);
    },
    async ptzExecute(action, direction) {
      let speed = this.remoteEP.cameraSetting.ptzSpeed || 1;
      if (!this.vmaatu) {
        try {
          let data = await this.$store.dispatch("getCollaborationPtzControl", {
            appointment: this.appointment,
            action: action,
            direction: direction,
          });
          console.log("success");
        } catch (err) {
          console.log("Error in PTC", err);
        }
      } else {
        if (action == "reset") {
          this.vmaatuPtz(action, direction, speed);
        } else if (direction == "Stop") {
          this.vmaatuPtz(action, direction, speed);
          clearTimeout(this.ptzTimer);
        } else {
          console.log("normal");
          this.vmaatuPtz(action, direction, speed);
          this.ptzTimer = setTimeout(() => {
            this.vmaatuPtz(action, direction, speed);
          }, 2000);
        }
      }
    },
    vmaatuPtz(action, direction, speed) {
      if (
        this.remoteEP.videoConfEPType == "VMAATU_RTC" ||
        this.remoteEP.videoConfEPType == "VMAATU_RTC_EXTERNAL"
      ) {
        let data = {
          payload: {
            action: action.toLowerCase(),
            direction: direction.toLowerCase(),
            speed: speed,
          },
          camera: this.remoteEP.cameraSetting
            ? this.remoteEP.cameraSetting.camera
            : "",
          port: this.remoteEP.cameraSetting
            ? this.remoteEP.cameraSetting.vendorId
            : "",
          controlType: "ptz",
        };

        //emit to endpoint message
        socket.emit("vmaatuVideoControl", {
          endpoint: this.remoteEP.name,
          data: data,
        });
      } else {
        let data = {
          payload: {
            phone: {
              type: this.remoteEP.videoConfEPType
                .replace("_", "")
                .toLowerCase(),
              firmware: this.remoteEP.videoConfDetails.firmwareVersion,
              number: this.remoteEP.videoConfDetails.phoneNumber,
              ip: this.remoteEP.videoConfDetails.ip,
              callIp: this.remoteEP.videoConfDetails.callIp,
              username: this.remoteEP.videoConfDetails.username,
              password: this.remoteEP.videoConfDetails.password,
              protocol: this.remoteEP.videoConfDetails.protocol.toLowerCase(),
              apiMode: this.remoteEP.videoConfDetails.apiMode.toLowerCase(),
            },
            action: action.toLowerCase(),
            direction: direction.toLowerCase(),
            speed: speed,
          },
          port:
            this.remoteEP.videoConfDetails.mode == "serial"
              ? this.remoteEP.videoConfDetails.comPort
              : "",
          controlType: "ptz",
          controlMode:
            this.remoteEP.videoConfDetails.mode == "clientHttp"
              ? "http"
              : this.remoteEP.videoConfDetails.mode,
        };

        //emit to endpoint message
        socket.emit("ciscoVideoControl", {
          endpoint: this.remoteEP.name,
          data: data,
        });
      }
    },
    startMoveFront() {
      let that = this;
      that.remoteCart.MOVING_FRONT = true;
      this.moveFrontHandler = setInterval(function () {
        if (that.remoteEP.roboticControls.controllerType == "app") {
          that.$refs.vmaatu.simpleMeetingsVmaatu.chatManager.sendToRoom(
            "command:a"
          );
        } else if (
          that.remoteEP.roboticControls.controllerType == "endpoint-service"
        ) {
          that.moveCart("a");
        }
      }, this.commandDelay);
    },
    endMoveFront() {
      this.remoteCart.MOVING_FRONT = false;
      clearInterval(this.moveFrontHandler);
    },

    startMoveNorthEast() {
      let that = this;
      that.remoteCart.MOVING_NORTH_EAST = true;

      this.moveNorthEastHandler = setInterval(function () {
        if (that.remoteEP.roboticControls.controllerType == "app") {
          that.$refs.vmaatu.simpleMeetingsVmaatu.chatManager.sendToRoom(
            "command:e"
          );
        } else if (
          that.remoteEP.roboticControls.controllerType == "endpoint-service"
        ) {
          that.moveCart("e");
        }
      }, this.commandDelay);
    },
    endMoveNorthEast() {
      this.remoteCart.MOVING_NORTH_EAST = false;
      clearInterval(this.moveNorthEastHandler);
    },

    startMoveSouthEast() {
      let that = this;
      that.remoteCart.MOVING_SOUTH_EAST = true;

      this.moveSouthEastHandler = setInterval(function () {
        if (that.remoteEP.roboticControls.controllerType == "app") {
          that.$refs.vmaatu.simpleMeetingsVmaatu.chatManager.sendToRoom(
            "command:f"
          );
        } else if (
          that.remoteEP.roboticControls.controllerType == "endpoint-service"
        ) {
          that.moveCart("f");
        }
      }, this.commandDelay);
    },
    endMoveSouthEast() {
      this.remoteCart.MOVING_SOUTH_EAST = false;
      clearInterval(this.moveSouthEastHandler);
    },

    startMoveSouthWest() {
      let that = this;
      that.remoteCart.MOVING_SOUTH_WEST = true;

      this.moveSouthWestHandler = setInterval(function () {
        if (that.remoteEP.roboticControls.controllerType == "app") {
          that.$refs.vmaatu.simpleMeetingsVmaatu.chatManager.sendToRoom(
            "command:g"
          );
        } else if (
          that.remoteEP.roboticControls.controllerType == "endpoint-service"
        ) {
          that.moveCart("g");
        }
      }, this.commandDelay);
    },
    endMoveSouthWest() {
      this.remoteCart.MOVING_SOUTH_WEST = false;
      clearInterval(this.moveSouthWestHandler);
    },

    startMoveNorthWest() {
      let that = this;
      that.remoteCart.MOVING_NORTH_WEST = true;

      this.moveNorthWestHandler = setInterval(function () {
        if (that.remoteEP.roboticControls.controllerType == "app") {
          that.$refs.vmaatu.simpleMeetingsVmaatu.chatManager.sendToRoom(
            "command:h"
          );
        } else if (
          that.remoteEP.roboticControls.controllerType == "endpoint-service"
        ) {
          that.moveCart("h");
        }
      }, this.commandDelay);
    },
    endMoveNorthWest() {
      this.remoteCart.MOVING_NORTH_WEST = false;
      clearInterval(this.moveNorthWestHandler);
    },

    startMoveBack() {
      let that = this;
      that.remoteCart.MOVING_BACK = true;

      this.moveBackHandler = setInterval(function () {
        if (that.remoteEP.roboticControls.controllerType == "app") {
          that.$refs.vmaatu.simpleMeetingsVmaatu.chatManager.sendToRoom(
            "command:b"
          );
        } else if (
          that.remoteEP.roboticControls.controllerType == "endpoint-service"
        ) {
          that.moveCart("b");
        }
      }, this.commandDelay);
    },
    endMoveBack() {
      this.remoteCart.MOVING_BACK = false;
      clearInterval(this.moveBackHandler);
    },

    startMoveLeft() {
      let that = this;
      that.remoteCart.MOVING_LEFT = true;

      this.moveLeftHandler = setInterval(function () {
        if (that.remoteEP.roboticControls.controllerType == "app") {
          that.$refs.vmaatu.simpleMeetingsVmaatu.chatManager.sendToRoom(
            "command:c"
          );
        } else if (
          that.remoteEP.roboticControls.controllerType == "endpoint-service"
        ) {
          that.moveCart("c");
        }
      }, this.commandDelay);
    },
    endMoveLeft() {
      this.remoteCart.MOVING_LEFT = false;
      clearInterval(this.moveLeftHandler);
    },

    startMoveRight() {
      let that = this;
      that.remoteCart.MOVING_RIGHT = true;

      this.moveRightHandler = setInterval(function () {
        if (that.remoteEP.roboticControls.controllerType == "app") {
          that.$refs.vmaatu.simpleMeetingsVmaatu.chatManager.sendToRoom(
            "command:d"
          );
        } else if (
          that.remoteEP.roboticControls.controllerType == "endpoint-service"
        ) {
          that.moveCart("d");
        }
      }, this.commandDelay);
    },
    endMoveRight() {
      this.remoteCart.MOVING_RIGHT = false;
      clearInterval(this.moveRightHandler);
    },

    startMoveUp() {
      this.remoteCart.TILTING_UP = true;
      let that = this;

      this.moveUpHandler = setInterval(function () {
        if (that.remoteEP.roboticControls.controllerType == "app") {
          that.$refs.vmaatu.simpleMeetingsVmaatu.chatManager.sendToRoom(
            "command:x"
          );
        } else if (
          that.remoteEP.roboticControls.controllerType == "endpoint-service"
        ) {
          that.moveCart("x");
        }
      }, this.commandDelay);
    },
    stopMoveUp() {
      this.remoteCart.TILTING_UP = false;
      clearInterval(this.moveUpHandler);
    },

    startMoveDown() {
      this.remoteCart.TILTING_DOWN = true;
      let that = this;

      this.moveDownHandler = setInterval(function () {
        if (that.remoteEP.roboticControls.controllerType == "app") {
          that.$refs.vmaatu.simpleMeetingsVmaatu.chatManager.sendToRoom(
            "command:y"
          );
        } else if (
          that.remoteEP.roboticControls.controllerType == "endpoint-service"
        ) {
          that.moveCart("y");
        }
      }, this.commandDelay);
    },
    stopMoveDown() {
      this.remoteCart.TILTING_DOWN = false;
      clearInterval(this.moveDownHandler);
    },

    async getPrescription(apptid, patientId) {
      try {
        let response = await this.$store.dispatch("getPrescription", {
          apptid: apptid,
          patientId: patientId,
        });

        if (response.data.length > 0) {
          this.prescription = response.data[response.data.length - 1];
        }
      } catch (err) {
        console.log(err);
      }
    },
    async endIcu() {
      swal
        .fire({
          text: this.$t("message.Are you sure you want to leave this appointment?"),
          type: "warning",
          showCancelButton: true,
          confirmButtonText: this.$t("message.YES, CONTINUE"),
        })
        .then(async (result) => {
          if (result.value) {
            let loader = this.$loading.show({
              // Optional parameters
              container: null,
              canCancel: false,
            });

            //get latest appt
            try {
              this.appointment = await this.$store.dispatch(
                "getLatestAppointment",
                {
                  appointment: this.appointment,
                }
              );
            } catch (err) {
              console.log("Error:", err);
            }

            if (this.appointment.multiparty.enabled) {
              //check if primary provider
              if (this.appointment.provider.providerId == this.user._id) {
                this.appointment.latestStatus = "Completed";
                this.appointment.appointmentStatus.push({
                  status: "Completed",
                  timestamp: new Date().getTime(),
                });
              } else {
                this.appointment.secondaryProviders.forEach(function (
                  provider
                ) {
                  if (provider.providerId == this.user._id) {
                    provider.status.push({
                      status: "Exited",
                      timestamp: new Date().getTime(),
                    });
                  }
                });
              }
            } else {
              this.appointment.latestStatus = "Completed";
              this.appointment.appointmentStatus.push({
                status: "Completed",
                timestamp: new Date().getTime(),
              });
            }

            this.appointment.createdFormatted = "";

            try {
              let updatedAppointmentdata = await this.$store.dispatch(
                "updateAppointment",
                this.appointment
              );

              this.appointment = updatedAppointmentdata;
              if (this.appointment.multiparty.enabled) {
                if (this.appointment.latestStatus == "Completed") {
                  let exitCount = 0;
                  //primary provider exited check for secondary providers
                  this.appointment.secondaryProviders.forEach(function (
                    provider
                  ) {
                    if (provider.status.find((st) => st.status == "Exited")) {
                      exitCount = exitCount + 1;
                    }
                  });
                  //if exitcount == no of secondary providers, then all providers are exited
                  if (exitCount >= this.appointment.secondaryProviders.length) {
                    this.ENDPOINT_SET_FREE = true;
                  }
                }
              } else {
                this.ENDPOINT_SET_FREE = true;
              }
              //only if last doctor exiting or if not multiparty
              if (
                this.ENDPOINT_SET_FREE ||
                !this.appointment.multiparty.enabled
              ) {
                //delete webex room
                try {
                  if (
                    this.appointment.webexTeams &&
                    this.appointment.webexTeams.roomId
                  ) {
                    await this.$store.dispatch(
                      "deleteWebexRoom",
                      this.appointment._id
                    );
                    await this.$refs[
                      "webex"
                    ].simpleMeetingsWebex.webexManager.endCall();
                  }
                } catch (err) {
                  console.log("Error deleting webex room", err);
                }

                //Fetching ICU endpoint
                let endpoint = await this.$store.dispatch(
                  "getEndpoint",
                  this.appointment.endpoint
                );

                endpoint.status = "Free";

                try {
                  //Updating ICU Endpoint
                  await this.$store.dispatch("updateEndPointStatus", {
                    endpointId: endpoint._id,
                    status: endpoint.status,
                  });

                  loader.hide();
                } catch {
                  loader.hide();
                  console.log("Error fetching endpoint");
                }
              }
              socket.emit("icuVisitClose", {
                endpoint: this.appointment.endpoint,
              });
              socket.emit("leaveRoom", {
                type: "endpoint",
                id: this.endpoint,
                userId: this.user._id,
              });
              socket.emit("leaveRoom", {
                type: "appointment",
                id: this.appointment._id,
                userId: this.user._id,
              });
              console.log("Redirecting doctor to MyAppointments");
              loader.hide();
              this.$router.push({ name: "message.Home" });
            } catch {
              loader.hide();
              console.log(
                "Error updating appointment details for " + this.appointmentId
              );
              this.$router.push({ name: "message.Home" });
            }
          }
        });
    },

    //Robotic Cart with Windows PC
    moveCart(direction) {
      let that = this;
      that.$http.post(
        that.baseUrl +
          "/endpointservice/" +
          that.remoteEP.name +
          "/roboticontrol/_execute",
        { command: direction }
      );
    },
  },
  beforeDestroy() {
    this.$root.onBackButton = null;
    if (this.$refs.vmaatu) {
      this.$refs.vmaatu.destroy();
    }
  },
};
</script>

<style scoped>
.close-button {
  z-index: 2001;
  position: absolute;
  inset-inline-end: 2rem;
  top: 1%;
}

@media screen and (max-height: 412px) {
  .close-button {
    top: 1%;
  }
}

/deep/.zone.joystick .front,
/deep/.zone.slider .front {
  background: #d6cccc !important;
  opacity: 0.9 !important;
}

/deep/.zone.joystick .back,
/deep/.zone.slider .back {
  background: #403d3d !important;
  opacity: 0.7 !important;
}

/deep/.zone.slider .back {
  width: 60px !important;
  margin-left: -30px !important;
  border-radius: 1em !important;
}

/*PTZ control buttons*/
/* The Circle menu */
.circleMenu,
.circleMenu .inner,
.circleMenu .inner > li {
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.mainBtn {
  display: block;
  width: 48px;
  height: 48px;
  position: relative;
  z-index: 20;
  background-color: #ffffff;
  -webkit-transition: -webkit-transform 0.3s ease;
  transition: -webkit-transform 0.3s ease;
  transition: transform 0.3s ease;
  transition: transform 0.3s ease, -webkit-transform 0.3s ease;
  border-radius: 100%;
}

.mainBtn:hover {
  cursor: pointer;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
}

.mainBtn:focus {
  outline: 0 !important;
}

.circleMenu .inner,
.circleMenu .inner > li .inner {
  display: block;
  width: 150px;
  height: 150px;
  background-color: rgba(96, 125, 139, 0.35);
  padding: 6px;
  -webkit-transition: width 0.3s ease, height 0.3s ease;
  transition: width 0.3s ease, height 0.3s ease;
  border-radius: 100%;
}

/*.circleMenu:hover .inner, .circleMenu .inner:hover .inner, .circleMenu .inner > li:hover .inner {
  width: 150px;
  height: 150px;
}*/

.circleMenu .inner > li,
.circleMenu .inner .inner > li,
.circleMenu .inner > li .inner > li {
  z-index: 10;
  -webkit-transition: left 0.3s ease, top 0.3s ease;
  transition: left 0.3s ease, top 0.3s ease;
}

.circleMenu .inner > li:nth-child(1),
.circleMenu .inner:hover .inner > li:nth-child(1),
.circleMenu .inner > li:hover .inner > li:nth-child(1) {
  left: 20%;
}

.circleMenu .inner > li:nth-child(2),
.circleMenu .inner:hover .inner > li:nth-child(2),
.circleMenu .inner > li:hover .inner > li:nth-child(2) {
  top: 20%;
}

.circleMenu .inner > li:nth-child(3),
.circleMenu .inner:hover .inner > li:nth-child(3),
.circleMenu .inner > li:hover .inner > li:nth-child(3) {
  left: 80%;
}

.circleMenu .inner > li:nth-child(4),
.circleMenu .inner:hover .inner > li:nth-child(4),
.circleMenu .inner > li:hover .inner > li:nth-child(4) {
  top: 80%;
}

.circleMenu .fa,
.circleMenu .inner > li {
  color: #ffffff;
}

/* Other stuff */

.floating-ptz .outer,
.floating-ptz .inner,
.cart-controls .outer,
.cart-controls .inner {
  margin: 0;
  padding: 0;
  list-style-type: none;
}

.circleMenu .inner > li .fa:hover {
  color: #2196f3;
  cursor: pointer;
}

.floating-ptz,
.cart-controls {
  position: absolute;
  inset-inline-end: 78%;
  top: 65%;
  transform: translate(-50%, -50%);

  /*z-index is set to 29 to come behind user menu*/
  z-index: 29;
}

.zoom-buttons {
  position: absolute;
  inset-inline-end: 0px;
  top: 65%;
  transform: translate(-50%, -50%);
  z-index: 29;
  list-style-type: none;
}

.zoom-buttons > li:nth-child(1) {
  margin-bottom: 20%;
}

.zoom-buttons > li:nth-child(2) {
  margin-bottom: 20%;
}

.zoom-buttons > li:hover {
  cursor: pointer;
}

.zoom-buttons .fa-stack {
  color: rgba(96, 125, 139, 0.35);
}

.battery-status {
  padding: 12px;
  position: absolute;
  left: 0;
  top: 0;
}
</style>
